import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface BehaviorState {
  customBehaviour: {
    skipEvaluationFlow: boolean
  };
}

const initialState: BehaviorState = {
  customBehaviour: {
    skipEvaluationFlow: false
  }
};

const behaviorSlice = createSlice({
  name: 'behavior',
  initialState,
  reducers: {
    updateBehaviorCustomBehaviour(
      state,
      action: PayloadAction<Partial<BehaviorState['customBehaviour']>>
    ) {
      state.customBehaviour = { ...state.customBehaviour, ...action.payload };
    }
  }
});

export const { updateBehaviorCustomBehaviour } = behaviorSlice.actions;
export default behaviorSlice.reducer;
